export default (item) => {
  let shopLocale = 'en'
  let customRetailers = ''
  if (window.theme.settings.shopLocale) shopLocale = window.theme.settings.shopLocale
  // check for custom retailers by default
  if (item.custom) customRetailers = getCustomRetailers(item.custom, shopLocale)

  // set custom retailers to default retailers if empty
  if (!customRetailers && item.retailers) customRetailers = item.retailers

  // check for Harperstacks Retailers
  if (window.theme.settings.supaduCatalog === 'harperstacks-us') {
    customRetailers = checkHCRetailers(item.isbn13)
  }

  if (!customRetailers.length || !window.theme.settings.bookDetailsSettings) return ''

  let selectLabel = 'Select Retailer'
  if (item.languages.select_retailer_label) selectLabel = item.languages.select_retailer_label
  let list = '<ul class="dropdown__inner">'
  list += `<li tabindex="0"><span>${selectLabel}</span></li><li><ul>`
  customRetailers.forEach((retailer) => {
    if (!retailer.path && !retailer.label) return
    list += `<li><a href="${retailer.path}" title="${retailer.label}" target="_blank" class="btn btn--full add-to-cart">${retailer.label}</a></li>`
  })
  list += '</li></ul>'
  const retailerType = window.theme.settings.bookDetailsSettings.retailer_links_view
  let retailerHeadline = shopLocale !== 'en' ? item.languages.retailer_headline : window.theme.settings.bookDetailsSettings.retailer_links_headline
  retailerHeadline = retailerHeadline !== '' ? `<span>${retailerHeadline}</span>` : ''
  return `<div class="product-form__retailers__inner ${retailerType}">${retailerHeadline}<div class="dropdown">${list}</div></div>`
}

function getCustomRetailers (custom, locale) {
  if (!custom.retailers) {
    return ''
  }
  const customRetailers = custom.retailers
  if (!customRetailers[`${locale}_language`]) {
    return ''
  }

  return Object.values(customRetailers[`${locale}_language`])
}

function checkHCRetailers (isbn13) {
  return [
    {
      label: 'Amazon',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=amazon`
    },
    {
      label: 'Barnes & Noble',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=barnesandnoble`
    },
    {
      label: 'Books-A-Million',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=booksamillion`
    },
    {
      label: 'Bookshop',
      path: `https://bookshop.org/a/397/${isbn13}`
    },
    {
      label: 'IndieBound',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=indiebound`
    },
    {
      label: 'Target',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=target`
    },
    {
      label: 'Walmart',
      path: `http://aps.harpercollins.com/hc?isbn=${isbn13}&retailer=walmar`
    }
  ]
}
